"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIClientSettingsEntityMaintenanceSettings = void 0;
const iclient_settings_entity_maintenance_settings_auto_creation_1 = require("./iclient-settings-entity-maintenance-settings-auto-creation");
function parseIClientSettingsEntityMaintenanceSettings(data) {
    if (typeof data.inactive_date === 'string')
        data.inactive_date = new Date(data.inactive_date);
    if (data.autoCreation !== null && typeof data.autoCreation === 'object')
        data.autoCreation = (0, iclient_settings_entity_maintenance_settings_auto_creation_1.parseIClientSettingsEntityMaintenanceSettingsAutoCreation)(data.autoCreation);
    return data;
}
exports.parseIClientSettingsEntityMaintenanceSettings = parseIClientSettingsEntityMaintenanceSettings;
